class HeaderBannerCarousel {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('.hbc-track');
    this.slides = Array.from(root.querySelectorAll('.hbc-slide'));
    this.dots = Array.from(root.querySelectorAll('.hbc-dot'));
    this.prevBtn = root.querySelector('.hbc-nav--prev');
    this.nextBtn = root.querySelector('.hbc-nav--next');
    this.current = 0;
    this.autoplay = root.dataset.autoplay === 'true';
    this.autoplaySpeed = (parseInt(root.dataset.autoplaySpeed, 10) || 5) * 1000;
    this.timer = null;

    if (this.slides.length <= 1) return;

    this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.current - 1));
    this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.current + 1));
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.go(parseInt(dot.dataset.index, 10)));
    });

    this.root.addEventListener('mouseenter', () => this.stop());
    this.root.addEventListener('mouseleave', () => this.start());
    this.root.addEventListener('focusin', () => this.stop());
    this.root.addEventListener('focusout', () => this.start());

    this.addSwipeSupport();

    if (this.autoplay) this.start();
  }

  go(index) {
    this.current = (index + this.slides.length) % this.slides.length;
    this.track.style.transform = `translateX(-${this.current * 100}%)`;
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.current));
  }

  start() {
    if (!this.autoplay) return;
    this.stop();
    this.timer = setInterval(() => this.go(this.current + 1), this.autoplaySpeed);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
  }

  addSwipeSupport() {
    let startX = 0;
    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      this.stop();
    }, { passive: true });

    this.track.addEventListener('touchend', (e) => {
      const deltaX = e.changedTouches[0].clientX - startX;
      if (Math.abs(deltaX) > 40) {
        this.go(this.current + (deltaX < 0 ? 1 : -1));
      }
      this.start();
    });
  }
}

document.querySelectorAll('.hbc').forEach((el) => new HeaderBannerCarousel(el));

document.addEventListener('shopify:section:load', (event) => {
  const el = event.target.querySelector('.hbc');
  if (el) new HeaderBannerCarousel(el);
});